import { CheckCircleFilled, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Space, Typography, Upload, message } from 'antd';
import type { RcFile } from 'antd/es/upload';
import type { DocumentType } from '../../types';
import { validateDocument } from './documentRules';

interface Props {
  type: DocumentType;
  label: string;
  hint: string;
  file: File | null;
  onChange: (file: File | null) => void;
}

/**
 * File picker for the *create* form. The investor does not exist yet, so nothing can be uploaded —
 * the chosen file is held in memory and sent once the investor record has been created. Validation
 * still runs immediately so mistakes surface before the form is submitted.
 */
export default function PendingDocumentPicker({ type, label, hint, file, onChange }: Props) {
  const beforeUpload = async (candidate: RcFile) => {
    const problem = await validateDocument(candidate, type);
    if (problem) {
      message.error(problem);
    } else {
      onChange(candidate);
    }
    return Upload.LIST_IGNORE;
  };

  return (
    <div style={{ marginBottom: 12 }}>
      <Typography.Text style={{ fontSize: 13 }}>{label}</Typography.Text>
      <div style={{ marginTop: 4 }}>
        {file ? (
          <Space>
            <CheckCircleFilled style={{ color: '#3EB780' }} />
            <Typography.Text ellipsis style={{ maxWidth: 200 }}>
              {file.name}
            </Typography.Text>
            <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={() => onChange(null)} />
          </Space>
        ) : (
          <Upload
            accept={type === 'agreement-video' ? '.mp4,.webm' : '.jpg,.jpeg,.png,.webp'}
            showUploadList={false}
            beforeUpload={beforeUpload}
          >
            <Button size="small" icon={<UploadOutlined />}>
              Choose file
            </Button>
          </Upload>
        )}
      </div>
      <Typography.Text type="secondary" style={{ fontSize: 11 }}>
        {hint}
      </Typography.Text>
    </div>
  );
}
